import {gql} from '@apollo/client';

import localForage from 'localforage';

import client, { getAPIUrl } from '../client';
import { makeid } from '../utils';

export async function getCurrentUser() {
  try {
    const { data } = await client.query({
      query: gql`query {
        moodler {
          me {
            imageUrl
            username
          }
        }
      }`,
    })
    let user = data?.moodler?.me
    return user
  } catch (e) {
    throw e
  }
}

async function refreshToken() {
  let strTokenAuth = await localForage.getItem('session')
  let tokenAuth = JSON.parse(strTokenAuth)
  let token = tokenAuth.token
  const data = await this.fetchAPI(
    `mutation refreshToken($token: String!) {
      refreshToken(token: $token) {
        token,
        payload,
        refreshExpiresIn
      }
    }
    `,
    {
      variables: {
        token
      }
    }
  )
  return data?.refreshToken
}

export async function startLogin() {
  const {
    protocol,
    hostname,
    port,
    pathname,
    search
  } = window.location
  const redirectTo = `${protocol}//${hostname}:${port}${pathname}?${search}`
  await localForage.setItem('redirectTo', redirectTo)
  const url = '/login' // `${import.meta.env.VITE_LOGIN_URL}?response_type=code&client_id=${import.meta.env.VITE_CLIENT_ID}&redirect_uri=${encodeURIComponent(import.meta.env.VITE_REDIRECT_URI)}`
  setTimeout(
    () => {
      window.location.href = url
    }, 
    500
  )
}

export async function generateTokenFromAuthorizationCode(code) {
  try {
    const response = await fetch(
      `${getAPIUrl()}/auth/api/token`,
      {
        method: 'POST',
        body: JSON.stringify({
          code    
        }), 
        headers: {
          'Content-Type': 'application/json'
        }
      }
    )
    const data = await response.json()
    return data?.tokenAuth
  } catch (e) {
    throw e
  }
}

export async function generateTokenFromUsernameAndPassword(username, password) {
  try {
    const response = await fetch(
      `${getAPIUrl()}/api/token/`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          username,
          password
        })
      }
    )
    if (response.status !== 200) {
      throw new Error("Invalid login")
    }
    const data = await response.json()
    return {
      token: data.access,
      refresh: data.refresh
    }
  } catch (e) {
    throw e
  }
}

export async function loginWithOTP(token) {
  const result = await generateTokenFromOTP(token)
  const { access: accessToken } = result
  await localForage.setItem('token', accessToken)
  let session = { 
    token: accessToken
  }
  await localForage.setItem('session', session)
  return session
}

export async function generateTokenFromOTP(token) {
  const response = await fetch(
    `${getAPIUrl()}/magic/api/otp`,
    {
      body: JSON.stringify({
        token
      }),
      method: 'POST'
    }
  )
  if (response.status !== 200) {
    throw new Error(response.error)
  }
  const data = await response.json()
  return data
}

export async function loginWithAuthorizationCode(code) {
  const result = await generateTokenFromAuthorizationCode(code)
  const { token } = result
  await localForage.setItem('token', token)
  const user = await getCurrentUser()
  let session = {
    id: makeid(23),
    user,
    token
  }
  await localForage.setItem('session', session)
  return session
}

export async function loginWithUsernameAndPassword(username, password) {
  const result = await generateTokenFromUsernameAndPassword(username, password)
  const { token } = result
  await localForage.setItem('token', token)
  const user = await getCurrentUser()
  let session = {
    id: makeid(23),
    user,
    token
  }
  await localForage.setItem('session', session)
  return session
}

export async function logout() {
  await localForage.removeItem("token")
  await localForage.removeItem("session")
}

export async function loginWithJwtToken(token) {
  await localForage.setItem('token', token)
  const user = await getCurrentUser()
  let session = {
    id: makeid(23),
    user,
    token
  }
  await localForage.setItem('session', session)
  return session     
}

export async function getSession() {
  const session = await localForage.getItem('session')

  return session
}

export async function createMagicLink(email) {
  const response = await fetch(
    `${getAPIUrl()}/magic/api/link`,
    {
      body: JSON.stringify({
        email
      }),
      method: 'POST'
    }
  )
  if (response.status !== 200) {
    throw new Error(response.error)
  }
  const data = await response.json()
  return data
}

export async function generateTokenFromMagicLink(token) {
  const response = await fetch(
    `${getAPIUrl()}/magic/api/token`,
    {
      body: JSON.stringify({
        token
      }),
      method: 'POST'
    }
  )
  if (response.status !== 200) {
    throw new Error(response.error)
  }
  const data = await response.json()
  return data
}

export async function loginWithMagicLink(token) {
  const result = await generateTokenFromMagicLink(token)
  const { access: accessToken, refresh } = result
  await localForage.setItem('token', accessToken)
  const user = await getCurrentUser()
  let session = {
    user,
    token: accessToken,
    refresh
  }
  await localForage.setItem('session', session)
  return session
}

export async function uploadFiles(files, onUpdate) {
  // @ts-ignore
  const token = await localForage.getItem('token');
  var data = new FormData()
  data.append('file', files[0])
  const response = await fetch(
    `${getAPIUrl()}/leads/api/uploads`,
    {
      body: data,
      method: 'POST', 
      headers: {
        'Authorization': `Bearer ${token}`
      }
    }
  )
  if (!response.ok) {
    throw new Error("Failed to upload file")
  }
  return await response.json()
}